import { ParsedContent } from "../ChatMessage";
import { ChatMessage as ChatMessageType } from "@/zapi-frontend/stores/chatStore";
export const getMessageStyles = (message: ChatMessageType, parsedContent: ParsedContent, parseError: boolean) => {
  const baseClasses = "rounded-2xl shadow-sm px-4 py-3 max-w-[90%] md:max-w-[75%] break-words text-base";

  if (message.role === "user") {
    return `${baseClasses} ml-auto bg-gradient-to-r from-blue-500 to-blue-600 text-white `;
  }

  if (parseError) {
    return `${baseClasses} mr-auto bg-red-50 border border-red-100`;
  }

  switch (parsedContent.type) {
    case "websearch":
      return `${baseClasses} mr-auto bg-white border border-blue-100`;
    case "error":
      return `${baseClasses} mr-auto bg-red-50 border border-red-100`;
    case "loading":
      return `${baseClasses} mr-auto bg-gray-50 border border-gray-100`;
    case "updateChapter":
      return `${baseClasses} mr-auto bg-gray-50 border-l-[3px] border-l-green-500`;
    case "multiAction":
      return `${baseClasses} mr-auto bg-yellow-50 border border-yellow-100`;
    case "agent":
      return `${baseClasses} mr-auto bg-gray-50 border-l-[3px] border-l-purple-500`;
    default:
      return `${baseClasses} mr-auto bg-white border border-gray-100`;
  }
};
